// extracted by mini-css-extract-plugin
export var label = "_63-1";
export var reminder = "_63-0";